import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import Colors from "../../../../../global/Colors";

export default function CustomNavChip({ path, title, active }) {
  const navigate = useNavigate();

  const handleNavigateTo = (path) => {
    navigate(`/${path}`);
  };

  return (
    <div
      className="rounded-full cursor-pointer"
      onClick={() => handleNavigateTo(path)}
      style={{
        backgroundColor: active ? Colors.blue[3] : Colors.blue[2],
      }}
    >
      <div style={{ padding: "16px" }}>
        <Typography
          style={{
            color: active ? Colors.white : Colors.black,
            fontWeight: "500",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          {title}
        </Typography>
      </div>
    </div>
  );
}
